import { firebase } from '../firebase';

export function addNoteToScoreCompetency(token, questionnaire, session, competency, note) {
    const addNoteToScoreCompetency = firebase.functions().httpsCallable('addNoteToScoreCompetency');
    return addNoteToScoreCompetency({
        token,
        questionnaire,
        session,
        competency,
        note
    });
}